import { z } from "zod";
export { interactiveCampusMapSchema } from "@digital-signage/interactive-experience/campus";
/** Draft references are never included in the published interactive bundle. */
export const authoringFloorPlansSchema = z.array(z.object({
    assetVersionId: z.string().uuid(),
    floorId: z.string().uuid(),
}).strict()).max(500).refine((plans) => new Set(plans.map((plan) => plan.floorId)).size === plans.length, "Each floor must have one authoring plan");
//# sourceMappingURL=interactive-campus.js.map